import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, Section } from "./LegalLayout";

const ConsentEn = () => (
  <LegalLayout
    title="Personal Data Processing Consent"
    updated="June 14, 2026"
    backLabel="← Back to Home"
    updatedPrefix="Updated"
  >
    <Section title="1. General Provisions">
      <p>
        By registering on <strong>swingmentor.pro</strong>, paying for services,
        or uploading videos, the user (hereinafter — "Data Subject"), acting
        freely and in their own interest, gives consent to sole trader KOKOV
        ALEKSANDR DMITRIEVICH (OGRNIP: 325784700333162, INN: 784302022304,
        address: Russia, Saint Petersburg, Komarovo, Tsvetochnaya 2A;
        hereinafter — "Controller") to process their personal data.
      </p>
      <p>
        This consent is provided in accordance with Art. 9 of Federal Law
        No. 152-FZ of 27.07.2006 "On Personal Data" and, where applicable,
        Art. 6–7 of Regulation (EU) 2016/679 (GDPR).
      </p>
    </Section>

    <Section title="2. Categories of Personal Data">
      <ul>
        <li>first name, last name;</li>
        <li>email address;</li>
        <li>golf handicap;</li>
        <li>
          original and processed golf swing videos, phase images, text
          recommendations, scores, and other analysis results;
        </li>
        <li>payment information (fact of payment, amount, payment identifier).</li>
      </ul>
    </Section>

    <Section title="3. Purposes of Processing">
      <ul>
        <li>registration and identification on swingmentor.pro;</li>
        <li>
          provision of automated golf swing analysis services and delivery of
          recommendations;
        </li>
        <li>payment processing and issuing receipts;</li>
        <li>user support and handling of enquiries;</li>
        <li>compliance with applicable law.</li>
      </ul>
    </Section>

    <Section title="4. Processing Actions and Methods">
      <p>
        Consent is given for the following actions: collection, recording,
        systematisation, accumulation, storage, updating (modification),
        retrieval, use, transfer (provision, access) to persons specified in
        Section 4 of the{" "}
        <Link to="/legal/privacy-en">Privacy Policy</Link>, anonymisation,
        blocking, deletion, and destruction — using automated means. Video
        processing is performed in an automated manner, including using artificial
        intelligence technologies.
      </p>
      <p>
        For users from Russia, collection, recording, systematisation,
        accumulation, storage, updating, and retrieval of personal data are
        carried out using databases located in the Russian Federation. For users
        from other countries, data is stored on a server in Germany (EU) in
        accordance with GDPR.
      </p>
      <p>
        The Data Subject also consents to the temporary transfer of the video
        and a technical job identifier to AI infrastructure providers for the
        sole purpose of performing the analysis. Account data and payment details
        are not transmitted together with the video, and the temporary copy is
        deleted after the processing attempt completes.
      </p>
    </Section>

    <Section title="5. Duration and Withdrawal of Consent">
      <p>
        This consent is valid from the moment it is given until the purposes of
        processing are achieved or until it is withdrawn. Original videos and
        temporary files are deleted after the analysis is complete or the job
        finally fails. Processed video is retained while the user has enabled the
        video saving setting — until that setting is disabled or the account is
        deleted. Other analysis results are stored in history until account
        deletion or until a confirmed deletion request is fulfilled.
      </p>
      <p>
        Consent may be withdrawn at any time by sending a request to{" "}
        <a href="mailto:info@swingmentor.pro">info@swingmentor.pro</a> with the
        subject "Withdraw Consent". The Controller will cease processing and
        destroy the data within 30 days of receiving the withdrawal request,
        except for data that must be retained by law (e.g. payment records).
      </p>
      <p>
        Withdrawal of consent may make further use of the service impossible.
      </p>
    </Section>
  </LegalLayout>
);

export default ConsentEn;
